module.exports = __webpack_public_path__ + "0d851ddd2efd93604e806b3f32460f14.png";